import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Send page view to Google Analytics 4
    if (typeof window.gtag !== 'undefined') {
      window.gtag('config', 'G-2M8WCYMK6L', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

export default RouteTracker;